import { call, put, takeLatest } from 'redux-saga/effects';

import { getOperationsHistory } from '../../services/API';
import { actionTypes, requestSuccess, requestFailure } from './actions';

function* getData(action) {
  const response = yield call(getOperationsHistory, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* taxesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
